/**
 * Günlük iş planı ve günlük raporların sabit listeleri (ADR 0051). Ekran ve doğrulama aynı listeyi
 * kullanır; liste dışı değer reddedilir.
 */

/** Departmanlar: BGM sekmeleri (Deck, Engine, Safety, Admin) + ortağın taslağı (ADR 0051 §4). */
export const DAILY_DEPARTMENTS = [
  'deck',
  'engine',
  'navigation',
  'safety',
  'environment',
  'interior',
  'admin',
  'all',
] as const;
export type DailyDepartment = (typeof DAILY_DEPARTMENTS)[number];

/** Öncelik BGM'deki gibi (Low / Medium / High). */
export const DAILY_PRIORITIES = ['low', 'medium', 'high'] as const;
export type DailyPriority = (typeof DAILY_PRIORITIES)[number];

/** Görev durumu (ADR 0051 §4); "overdue" saklanmaz, türer. */
export const DAILY_TASK_STATUSES = ['planned', 'in_progress', 'completed', 'cancelled'] as const;
export type DailyTaskStatus = (typeof DAILY_TASK_STATUSES)[number];

/**
 * Günlük rapor türleri (ADR 0051 §5). Noon Report sefer modülündedir (ADR 0022) ve burada
 * çoğaltılmaz (ADR 0051 §1).
 */
export const DAILY_REPORT_KINDS = ['daily', 'port', 'defect_observation', 'safety'] as const;
export type DailyReportKind = (typeof DAILY_REPORT_KINDS)[number];

export const DAILY_WEATHER = ['good', 'fair', 'moderate', 'poor', 'bad'] as const;
export const DAILY_SEA_STATES = ['calm', 'slight', 'moderate', 'rough', 'very_rough'] as const;
export const DAILY_OBSERVATION_CATEGORIES = ['defect', 'observation'] as const;
export const DAILY_SAFETY_RESULTS = ['passed', 'partial', 'failed'] as const;

/** Rapor şemasının sürümü (`daily_reports.schema`). */
export const DAILY_REPORT_SCHEMA_VERSION = 1;

/** Onay matrisindeki kayıt türü (ADR 0051 §6). */
export const DAILY_REPORT_RECORD = 'daily_report';

/** Özetin en uzun hali: BGM'deki sayaç "60/1000". */
export const DAILY_SUMMARY_MAX = 1000;
